/**
 * Константы поддержки и багрепортов (docs/process/05-support-and-feedback.md §П5.2).
 *
 * Назначение файла: категории обращений и лимиты полей — единый источник для сервера и клиента.
 */

/** Категории обращений игрока (§П5.3). */
export const SUPPORT_CATEGORIES = [
  "money",
  "land",
  "combat",
  "geolocation",
  "behavior",
  "payment",
  "idea",
] as const;

export type SupportCategory = (typeof SUPPORT_CATEGORIES)[number];

/** Максимальная длина текста игрока в жалобе. */
export const SUPPORT_MESSAGE_MAX_LENGTH = 1000;

/** Сколько последних строк журнала прикладывает сервер к жалобе. */
export const SUPPORT_LEDGER_SNAPSHOT_LIMIT = 50;

/** Сколько последних клиентских ошибок уходит в жалобу. */
export const SUPPORT_CLIENT_ERRORS_LIMIT = 20;
